import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

type AutoCompleteProps = {
  label: string;
  options: any[];
  formik: any;
  name: string;
  disabled?: boolean;
};

export default function BaseAutoComplete({
  label,
  options,
  formik,
  name,
  disabled,
}: AutoCompleteProps) {
  return (
    <Autocomplete
      disablePortal
      disabled={disabled}
      options={options}
      value={
        options.find((option) => option.id === formik.values[name]) || null
      } // Set the correct value based on formik
      onChange={(event, newValue) => {
        formik.setFieldValue(name, newValue ? newValue.id : ""); // Set the field value to the selected option's id
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          {option.label}
        </li>
      )}
      isOptionEqualToValue={(option, value) => option.id === value} // Compare by id
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
}
